<script setup>
const nuxtApp = useNuxtApp();
const { getPage } = useWpApi();
const { data, error } = getPage("/media/", nuxtApp);
// if (
//   error.value ||
//   data.value.length === 0 ||
//   (!isNaN(data.value?.length) && !data.value.length)
// ) {
//   throw createError({
//     statusCode: 404,
//     statusMessage: process.dev
//       ? "Page Not Found - ...slugs.vue"
//       : "Page Not Found",
//   });
// }
const heroModule = computed(() =>
  data.value?.acf?.page_modules?.find(
    (module) => module.acf_fc_layout === "hero"
  )
);

const shouldSetHeroAsSeoImage = computed(
  () => !data.value?.yoast_head_json?.og_image
);
const heroSeoImage = useOgImageSubpages(heroModule.value);

const seoImageSubPages = computed(() => {
  if (shouldSetHeroAsSeoImage.value) return heroSeoImage;
  return { ...data.value?.yoast_head_json?.og_image };
});

// console.log("media data: ", toRaw(data.value));
const hasAlreadyScrolled = ref(false);
const scrollNav = (scrollToBottom) => {
  if (!process.client) return;
  const hero = document.querySelector(".hero-module");
  // if (scrollToBottom && !hasAlreadyScrolled.value && hero) {
  //   window.scrollTo({
  //     top: hero.getBoundingClientRect().bottom - 60,
  //     behavior: "smooth",
  //   });
  //   hasAlreadyScrolled.value = true;
  // }
  if (hero) {
    window.scrollTo({
      top:
        hero.getBoundingClientRect().top +
        document.documentElement.scrollTop +
        hero.offsetHeight -
        60,
      behavior: "smooth",
    });
  }
};
</script>

<template>
  <div class="media-task-page">
    <Hero v-bind="heroModule" :isSubPage="true" class="hero-module" />
    <SubNavigation type="media" @subnav-click="scrollNav" />

    <NuxtLayout name="taskpage">
      <NuxtPage
        :transition="{ name: 'fade', mode: 'out-in' }"
        class="subpage"
        :parentSeoImage="seoImageSubPages"
      />
    </NuxtLayout>
  </div>
</template>

<style lang="postcss" scoped>
div {
}
</style>
